import React from 'react';
import dayjs from 'dayjs';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';

const isoWeek = require('dayjs/plugin/isoWeek');

dayjs.extend(isoWeek);

export class DaysTopRow extends React.Component {
  static propTypes = {
    isXsScreen: PropTypes.any
  };

  getLabel = label => {
    const { isXsScreen } = this.props;
    if (isXsScreen) {
      label = label + 'Short';
    }
    return label;
  };

  getWeekdays() {
    let weeks = [];
    let begin = dayjs()
      .startOf('week')
      .isoWeekday(1);

    for (let i = 0; i < 5; i++) {
      weeks.push(
        <div key={`toprow-${i}`} className="basic-analytics-top-table-tile">
          {begin.add(i, 'd').format('ddd')}
        </div>
      );
    }
    return weeks;
  }

  render() {
    return (
      <div className="basic-anayltics-table-header-container">
        <div className="basic-analytics-top-table-tile first"></div>
        {this.getWeekdays()}
        <div className="basic-analytics-top-table-tile">{I18n.t(this.getLabel('classroomAnalytics.weekend'))}</div>
        <div className="basic-analytics-top-table-tile">{I18n.t(this.getLabel('classroomAnalytics.change'))}</div>
      </div>
    );
  }
}

export default DaysTopRow;
